import apiRequest from "../../utils/apiRequest";

/**
 * Services HTTP du domaine ExamRequest.
 *
 * <p>Contrat back :
 * <ul>
 *   <li>POST /request-exam → 201 + Long (id).</li>
 *   <li>GET /request-exam/{id} → ExamRequestResponse.</li>
 *   <li>GET /request-exam/by-patient/{patientId} → List&lt;ExamRequestResponse&gt;
 *       (non paginé — réponse tableau plat).</li>
 *   <li>DELETE /request-exam/{id} → void.</li>
 *   <li>GET /request-exam/exam-request-pdf/{id} → application/pdf inline.</li>
 * </ul>
 */

export const createExamRequest = async (payload) => {
  return apiRequest.post("/request-exam", payload);
};

export const getExamRequestById = async (id) => {
  if (id == null) {
    return { ok: false, status: 0, message: "id manquant", error: "BadRequest" };
  }
  return apiRequest.get(`/request-exam/${id}`);
};

export const deleteExamRequest = async (id) => {
  if (id == null) {
    return { ok: false, status: 0, message: "id manquant", error: "BadRequest" };
  }
  return apiRequest.del(`/request-exam/${id}`);
};

/**
 * Liste des demandes d'examens d'un patient (tableau plat, non paginé).
 *
 * @param {number} patientId
 */
export const getExamRequestsByPatient = async (patientId) => {
  if (patientId == null) {
    return { ok: false, status: 0, message: "patientId manquant", error: "BadRequest" };
  }
  return apiRequest.get(`/request-exam/by-patient/${patientId}`);
};
